/**
 * @generated SignedSource<<a7c6c5dbd8eb08f103adecc53342a48c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type versionDates_softwareReleasesLaunchCard$data = {
  readonly canEdit: boolean | null | undefined;
  readonly id: string;
  readonly releaseDate: AGG$DateTime | null | undefined;
  readonly startDate: AGG$DateTime | null | undefined;
  readonly " $fragmentType": "versionDates_softwareReleasesLaunchCard";
};
export type versionDates_softwareReleasesLaunchCard$key = {
  readonly " $data"?: versionDates_softwareReleasesLaunchCard$data;
  readonly " $fragmentSpreads": FragmentRefs<"versionDates_softwareReleasesLaunchCard">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "versionDates_softwareReleasesLaunchCard",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "canEdit"
    },
    {
      "kind": "ScalarField",
      "name": "startDate"
    },
    {
      "kind": "ScalarField",
      "name": "releaseDate"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "4dcf74d53cdeafe5bdc663fa3f4c36e4";

export default node;
